<form
	class="modal-form modal-scroll pt-3"
	[formGroup]="form"
	(ngSubmit)="stepOneSubmit()"
	autocomplete="off"
	novalidate
>
	<div class="col-12 form-group">
		<div class="row">
			<div class="col-md-12 col-lg-6 d-flex flex-column">
				<label for="fname"
					>{{ page?.groupName }}<span class="required-asterisk">*</span></label
				>
				<input
					id="groupName"
					formControlName="name"
					type="groupName"
					placeholder="{{ page?.groupName }}"
					class="form-control {{ isFieldDisabled ? 'select-disable' : '' }}"
					[readonly]="isFieldDisabled"
				/>
				<div *ngIf="f.name.errors && f.name.touched" class="invalid-feedback">
					<div *ngIf="f.name.errors.required || f.name.errors?.['whitespace']">
						{{ validationMessage.groupName.required }}
					</div>
				</div>
			</div>
			<div class="col-md-12 col-lg-6 d-flex flex-column">
				<label for="lname"
					>{{ page?.org }}<span class="required-asterisk">*</span></label
				>
				<select
					formControlName="organizationUUID"
					(change)="onSelectOrganization()"
					class="{{ isFieldDisabled ? 'select-disable' : '' }}"
					readonly="isFieldDisabled"
				>
					<option [ngValue]="null" selected>{{ page?.selectOrg }}</option>
					<option
						*ngFor="let organization of organizations"
						[value]="organization.uuid"
					>
						{{ organization.name }}
					</option>
				</select>
				<div
					*ngIf="f.organizationUUID.errors && f.organizationUUID.touched"
					class="invalid-feedback"
				>
					<div *ngIf="f.organizationUUID.errors.required">
						{{ validationMessage.organization.required }}
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="col-12 form-group">
		<div class="row">
			<div class="col-md-12 col-lg-6">
				<label for="startDate"
					>{{ page?.startDate }} <span class="required-asterisk">*</span></label
				>
				<input
					id="startDate"
					type="text"
					formControlName="startDate"
					placement="top"
					placeholder="{{ page?.startDate }}"
					class="form-control {{ isFieldDisabled ? 'select-disable' : '' }}"
					readonly="isFieldDisabled"
					bsDatepicker
					[bsConfig]="{ showWeekNumbers: false }"
				/>
				<div
					*ngIf="f.startDate.errors && f.startDate.touched"
					class="invalid-feedback"
				>
					<div *ngIf="f.startDate.errors.required">
						{{ validationMessage.date.required }}
					</div>
				</div>
			</div>
			<div class="form-group col-md-12 col-lg-6">
				<label for="endDate">{{ page?.endDate }} </label>
				<input
					id="endDate"
					formControlName="endDate"
					[ngClass]="{ 'danger-class': f.endDate.errors && f.endDate.touched }"
					type="text"
					placeholder="{{ page?.endDate }}"
					class="form-control"
					bsDatepicker
					[bsConfig]="{ showWeekNumbers: false }"
					placement="top"
					readonly
				/>
				<div
					*ngIf="f.endDate.errors && f.endDate.touched"
					class="invalid-feedback"
				>
					{{ page?.endDateEqualOrGreater }}
				</div>
			</div>
		</div>
	</div>
	<div class="col-12 d-flex align-items-start">
		<label for="public" class="pr-2">{{ page?.isPublic }}</label>
		<span
			[ngbTooltip]="page?.publicGroupDef"
			triggers="click"
			tooltipClass="my-custom-class"
			placement="top"
		>
			<span class="info-circle">
				<img src="assets/img/info-ico-card.svg" alt="info" />
			</span>
		</span>
		<div class="toggle-switch form-group pl-3">
			<div class="button b2" id="button-13">
				<input
					formControlName="public"
					type="checkbox"
					class="checkbox"
					id="checkMarak"
				/>
				<div class="knobs">
					<span></span>
				</div>
				<div class="layer"></div>
			</div>
		</div>
	</div>

	<div class="col-12 form-group">
		<div class="row">
			<div
				class="col-md-12 col-lg-6 d-flex flex-column mb-3 mb-lg-0 multiselect-dropdown"
			>
				<label for="visibleuser" class="d-flex">
					<span class="pr-2">{{ page?.visibleToUser }}</span>
					<span
						[ngbTooltip]="page?.groupVisibleToUser"
						triggers="click"
						tooltipClass="my-custom-class"
						placement="top"
					>
						<span class="info-circle">
							<img src="assets/img/info-ico-card.svg" alt="info" />
						</span>
					</span>
				</label>
				<ng-multiselect-dropdown
					[formControl]="f.visibleToUserUUIDs"
					[placeholder]="page?.selectAll"
					[settings]="dropdownSettings"
					[data]="userData"
					(onDropDownClose)="onDropDownClose($event)"
					(onSelect)="onItemSelect($event)"
					(onSelectAll)="onSelectAll($event)"
				>
				</ng-multiselect-dropdown>
			</div>
			<!-- <div class="col-md-12 col-lg-6 d-flex flex-column">
				<label for="visiblecollection" class="d-flex">
					<span class="pr-2">{{ page?.visibleToUserTag }} </span>
					<span
						[ngbTooltip]="page?.groupVisibleToUserTag"
						triggers="click"
						tooltipClass="my-custom-class"
						placement="top"
					>
						<span class="info-circle">
							<img src="assets/img/info-ico-card.svg" alt="info" />
						</span>
					</span>
				</label>
				<ng-multiselect-dropdown
					name="Collections"
					[formControl]="f.visibleToTagUUIDs"
					[placeholder]="page?.selectTag"
					[settings]="dropdownSettings"
					[data]="collectionData"
					(onDropDownClose)="onDropDownClose($event)"
					(onSelect)="onItemSelect($event)"
					(onSelectAll)="onSelectAll($event)"
				>
				</ng-multiselect-dropdown>
				<div class="invalid-feedback"></div>
			</div> -->
		</div>
	</div>
	<div class="col-12 d-flex">
		<label class="container-chk">
			{{ page?.enrollInGroup }}
			<input type="checkbox" formControlName="isEnroll" />
			<span class="checkmark"></span>
		</label>
		<span
			[ngbTooltip]="page?.adminEnrollDef"
			triggers="click"
			tooltipClass="my-custom-class"
			placement="top"
			class="pl-2"
		>
			<span class="info-circle">
				<img src="assets/img/info-ico-card.svg" alt="info" />
			</span>
		</span>
	</div>
</form>
<div
	class="d-flex justify-content-center align-items-center border-top pt-3 btn-row-c"
>
	<button (click)="decline()" type="button" class="btn btn-md">
		{{ page?.exit }}
	</button>
	<div class="d-flex mr-3">
		<button
			cdkStepperNext
			type="button"
			(click)="stepOneSubmit()"
			[disabled]="!form.valid"
			class="btn btn-ex-small btn-outline btn-outline-purple mx-2"
		>
			<i class="fas fa-chevron-right"></i>
		</button>
	</div>
</div>
